/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInterestAccrualRangeRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetInterestAccrualRangeResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getInterestAccrualRange = (request: GetInterestAccrualRangeRequest, options?: CashRequestOptions) => post<GetInterestAccrualRangeRequest, GetInterestAccrualRangeResponse>("/2.0/cash/get-interest-accrual-range", request, {...options, rejectOnError: true })